var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraining({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 84.25",
    style: {
      enableBackground: "new 0 0 122.88 84.25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.54,0h82.81c1.35,0,2.46,1.11,2.46,2.46v14.43h0.07v51.9v2.88v0.62H39.51v-3.5h79.87V17.5H32.61V4.93 C32.61,2.22,34.83,0,37.54,0L37.54,0z M0.01,41.38c-0.31-5.8,4.45-7.28,10.9-6.9l8.14,9.07l7.97-8.95l19.74-0.11 c7.46,0.85,5.89,8.65,0,8.98H33.84L30.8,61.73l-2.3,18.54c-0.6,1.96-1.8,3.24-3.53,3.9l-11.23,0.08c-2.26-0.34-3.61-1.66-4.01-3.98 L7.98,63.76c-4.6,0.44-6.14-2.82-6.62-7.54L0.01,41.38L0.01,41.38z M18.56,9.77c5.53,0,10.01,4.48,10.01,10.01 c0,5.53-4.48,10.01-10.01,10.01c-5.53,0-10.01-4.48-10.01-10.01C8.54,14.26,13.03,9.77,18.56,9.77L18.56,9.77z M18.94,39.29 l-6.34-6.95l1.87-1.49c2.75,1.15,5.48,1.15,8.18,0l2.56,1.52L18.94,39.29L18.94,39.29z M66.04,4.48c2.01,0,3.64,1.63,3.64,3.64 c0,2.01-1.63,3.64-3.64,3.64c-2.01,0-3.64-1.63-3.64-3.64C62.4,6.11,64.03,4.48,66.04,4.48L66.04,4.48z M45.33,4.48 c2.01,0,3.64,1.63,3.64,3.64c0,2.01-1.63,3.64-3.64,3.64c-2.01,0-3.64-1.63-3.64-3.64C41.69,6.11,43.32,4.48,45.33,4.48L45.33,4.48 z M55.68,4.48c2.01,0,3.64,1.63,3.64,3.64c0,2.01-1.63,3.64-3.64,3.64c-2.01,0-3.64-1.63-3.64-3.64 C52.04,6.11,53.67,4.48,55.68,4.48L55.68,4.48z M109.11,6.13c-0.37-0.37-0.37-0.98,0-1.35c0.37-0.37,0.98-0.37,1.35,0l2,2l2-2 c0.37-0.37,0.98-0.37,1.35,0c0.37,0.37,0.37,0.98,0,1.35l-2,2l2,2c0.37,0.37,0.37,0.98,0,1.35c-0.37,0.37-0.98,0.37-1.35,0l-2-2 l-2,2c-0.37,0.37-0.98,0.37-1.35,0c-0.37-0.37-0.37-0.98,0-1.35l2-2L109.11,6.13L109.11,6.13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.4795ab2407f1164a734f4316ac5a0e23.svg";
export { ForwardRef as ReactComponent };